module.exports = __webpack_public_path__ + "37a73035.svg";